export { ABOUT, PROGRAM, COST, DIPLOMA } from './constants'
export type { THeaderProps } from './types'
